var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3029 71.8751C21.3115 69.3351 26.7528 65.0172 32.4498 68.0652C39.571 71.8751 40.1188 79.4947 37.9277 83.3047C35.7365 87.1146 26.9719 90.3802 22.0418 86.026C18.0978 82.5427 17.722 79.5954 18.0872 77.4183",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7174 69.0197C79.6815 69.2268 77.2816 75.2232 76.8361 78.1954L77.4683 81.3247C78.1857 83.2409 80.8251 87.3129 85.6431 88.271C91.6655 89.4686 97.2486 82.7693 97.2509 78.6934C97.2531 74.6175 93.2623 68.7607 85.7174 69.0197Z",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2279 77.5599C9.9915 77.2404 5.51871 75.8346 5.51871 72.7676C5.51871 68.9338 3.6018 33.4709 5.51871 30.5956C7.43562 27.7202 9.35253 24.8448 12.2279 24.8448C15.1033 24.8448 61.4704 21.9695 65.3043 24.8448C69.1381 27.7202 67.2212 36.3462 71.055 36.3462C74.8888 36.3462 87.9458 35.3878 89.8627 38.2631C91.7796 41.1385 102.323 55.5153 105.198 59.3491C108.073 63.183 106.156 74.6845 103.281 75.6429",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5595 45.1108C84.2199 45.1108 77.4352 45.1108 77.0134 45.1108C76.4861 45.1108 74.9041 51.9873 78.5953 52.6125C81.5482 53.1126 88.6141 52.8209 91.778 52.6125",
    stroke: "#EF533F",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4446 32.6667L71.5557 71.5556",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47705 59.3489L42.8983 59.3489",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7322 78.5182C53.0778 77.0716 64.9428 76.6012 69.7351 78.5182",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H112V112H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtC);
export default __webpack_public_path__ + "static/media/vt_c.fbf6e1dcf5472b72e08574e92fd86d42.svg";
export { ForwardRef as ReactComponent };